/* eslint-disable react/no-unused-state */
import React from "react";

import cx from "classnames";
import PropTypes from "prop-types";

import { accessor } from "../../utils/propTypes";
import { mergeComponents } from "./common";
import { DnDContext } from "./DnDContext";
import EventContainerWrapper from "./EventContainerWrapper";
import WeekWrapper from "./WeekWrapper";

export default function withDragAndDrop(Calendar) {
	class DragAndDropCalendar extends React.Component {
		static propTypes = {
			...Calendar.propTypes,

			onEventDrop: PropTypes.func,
			onEventResize: PropTypes.func,
			onDragStart: PropTypes.func,
			onDragOver: PropTypes.func,
			onDropFromOutside: PropTypes.func,

			dragFromOutsideItem: PropTypes.func,

			draggableCondition: accessor,
			resizableCondition: accessor,
			selectableCondition: accessor,

			selectable: PropTypes.oneOf([true, false, "ignoreEvents"]),
		};

		static defaultProps = {
			...Calendar.defaultProps,
			draggableCondition: () => false,
			resizableCondition: () => false,
			selectableCondition: () => true,
		};

		constructor(...args) {
			super(...args);

			const { components } = this.props;

			this.components = mergeComponents(components, {
				eventContainerWrapper: EventContainerWrapper,
				weekWrapper: WeekWrapper,
			});

			this.state = { interacting: false };
		}

		getDnDContextValue() {
			return {
				draggable: {
					onStart: this.handleInteractionStart,
					onEnd: this.handleInteractionEnd,
					onBeginAction: this.handleBeginAction,
					onDropFromOutside: this.props.onDropFromOutside,
					dragFromOutsideItem: this.props.dragFromOutsideItem,
					draggableCondition: this.props.draggableCondition,
					resizableCondition: this.props.resizableCondition,
					selectableCondition: this.props.selectableCondition,
					dragAndDropAction: this.state,
				},
			};
		}

		defaultOnDragOver = event => {
			event.preventDefault();
		};

		handleBeginAction = (event, action, direction) => {
			this.setState({ event, action, direction });
			const { onDragStart } = this.props;
			if (onDragStart) onDragStart({ event, action, direction });
		};

		handleInteractionStart = () => {
			if (this.state.interacting === false) this.setState({ interacting: true });
		};

		handleInteractionEnd = interactionInfo => {
			const { action, event } = this.state;
			if (!action) return;

			this.setState({
				action: null,
				event: null,
				interacting: false,
				direction: null,
			});

			if (interactionInfo == null) return;

			interactionInfo.event = event;
			const { onEventDrop, onEventResize } = this.props;
			if (action === "move" && onEventDrop) onEventDrop(interactionInfo);
			if (action === "resize" && onEventResize) onEventResize(interactionInfo);
		};

		render() {
			const { selectable, elementProps, ...props } = this.props;
			const { interacting } = this.state;

			delete props.onEventDrop;
			delete props.onEventResize;
			props.selectable = selectable ? "ignoreEvents" : false;

			const elementPropsWithDropFromOutside = this.props.onDropFromOutside
				? {
						...elementProps,
						onDragOver: this.props.onDragOver || this.defaultOnDragOver,
					}
				: elementProps;

			props.className = cx(props.className, "fbc-addons-dnd", { "fbc-addons-dnd-is-dragging": !!interacting });

			const context = this.getDnDContextValue();
			return (
				<DnDContext.Provider value={context}>
					<Calendar {...props} elementProps={elementPropsWithDropFromOutside} components={this.components} />
				</DnDContext.Provider>
			);
		}
	}

	return DragAndDropCalendar;
}
